var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      style: _vm.color ? "color: " + _vm.color + ";" : "",
      attrs: { column: "" }
    },
    [
      _vm.showCategory
        ? _c(
            "v-layout",
            {
              staticStyle: { color: "black" },
              attrs: { "align-content-start": "", "justify-center": "" }
            },
            [
              _c("v-flex", [
                _vm._v(
                  _vm._s(_vm.value.category) +
                    _vm._s(
                      !!_vm.value.displayName && " -- " + _vm.value.displayName
                    )
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.value.category === "Bank transfer"
        ? [
            _c("PaymentBankTransferWidget", {
              attrs: { fullDetail: _vm.fullDetail },
              model: {
                value: _vm.value,
                callback: function($$v) {
                  _vm.value = $$v
                },
                expression: "value"
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.value.category === "Bill pay"
        ? [
            _c("PaymentBillPayWidget", {
              attrs: { fullDetail: _vm.fullDetail },
              model: {
                value: _vm.value,
                callback: function($$v) {
                  _vm.value = $$v
                },
                expression: "value"
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.value.category === "Check"
        ? [
            _c("PaymentCheckWidget", {
              attrs: { fullDetail: _vm.fullDetail },
              model: {
                value: _vm.value,
                callback: function($$v) {
                  _vm.value = $$v
                },
                expression: "value"
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b2e5aea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2e5aea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaymentWidget.vue
// module id = null
// module chunks = 